import React from 'react';
import _get from 'lodash/get';
import PropTypes from 'prop-types';

export default function withConfirmationMessages(WrappedComponent, messages) {
  return class extends React.Component {
    static propTypes = {
      amount: PropTypes.number,
      confirmationNumber: PropTypes.string,
      giftaidFlag: PropTypes.bool,
      isVoucherFlow: PropTypes.bool,
      orgName: PropTypes.string,
      postBackData: PropTypes.object,
      rp_status: PropTypes.bool,
      signUpStatus: PropTypes.bool,
      recurringConfirmationId: PropTypes.string,
      receiptId: PropTypes.string,
    };

    getGiftAidConfText = (label) => {
      if (this.props.giftaidFlag) {
        return this.props.rp_status ? label.giftAidRecurring : label.giftAid;
      }
      return '';
    };

    getYourDonationLabel = (label) => {
      let yourDonation = label.yourdonation;
      if (this.props.isVoucherFlow) {
        yourDonation = _get(label, 'voucher.yourdonation', label.yourdonation);
      }
      yourDonation =
        yourDonation && yourDonation.replace('{amount}', this.props.amount);
      yourDonation =
        yourDonation && yourDonation.replace('{orgName}', this.props.orgName);
      return yourDonation;
    };

    getYourRPDonationLabel = (label) => {
      let yourRPdonation = label.yourRPdonation;
      yourRPdonation =
        yourRPdonation && yourRPdonation.replace('{amount}', this.props.amount);
      yourRPdonation =
        yourRPdonation &&
        yourRPdonation.replace('{orgName}', this.props.orgName);
      return yourRPdonation;
    };

    getReturnTextLabel = (label) => {
      let returnText = label.returnText;
      returnText =
        returnText && returnText.replace('{orgName}', this.props.orgName);
      return returnText;
    };

    getReturnTextMemberLabel = (label) => {
      let returnTextMember = label.returnTextMember;
      returnTextMember =
        returnTextMember &&
        returnTextMember.replace('{orgName}', this.props.orgName);
      return returnTextMember;
    };

    getReturnToLabel = (label) => {
      let returnTo = label.returnto;
      returnTo = returnTo && returnTo.replace('{orgName}', this.props.orgName);
      return returnTo;
    };

    getTxnIdLabel = (label) => {
      let txnId = label.txnId;
      let id = this.props.rp_status
        ? this.props.recurringConfirmationId
        : this.props.receiptId;
      id = id || this.props.confirmationNumber;

      txnId = txnId && txnId.replace('{txnId}', id);
      return txnId;
    };

    getSignupProps = (label) => {
      return {
        signUpStatus: this.props.signUpStatus,
        successMessage: label.successMessage,
        failMessage: label.failMessage,
      };
    };

    render() {
      const { label = {} } = messages || {};
      const returnText = this.getReturnTextLabel(label);
      const returnTextMember = this.getReturnTextMemberLabel(label);
      const returnTo = this.getReturnToLabel(label);
      const txnId = this.getTxnIdLabel(label);
      const yourRPdonation = this.getYourRPDonationLabel(label);
      const giftAidConfText = this.getGiftAidConfText(label);
      const yourDonation = this.getYourDonationLabel(label);
      const signUpProps = this.getSignupProps(label);
      return (
        <WrappedComponent
          {...this.props}
          label={label}
          messages={messages}
          yourDonation={yourDonation}
          returnText={returnText}
          returnTextMember={returnTextMember}
          returnTo={returnTo}
          txnId={txnId}
          yourRPdonation={yourRPdonation}
          giftAidConfText={giftAidConfText}
          signUpProps={signUpProps}
        />
      );
    }
  };
}
